import {GenericDgSearchResults} from "./generic.dg-search-results.model";
import {PartnerShopOrder} from "../partner-shop-order.model";

export class PartnerShopOrderDgSearchResults extends GenericDgSearchResults {
  public results: PartnerShopOrder[];

  constructor(total: number, results: PartnerShopOrder[], csrfToken: string) {
    super();
    this.total = total;
    this.results = results;
    this.csrfToken = csrfToken;
  }
}

